import React, { useState } from "react";
import Modal from "react-modal";
import SearchNButtons from "../../common-components/SearchNButtons";
import IngForm from "./IngForm";

const IngredientsFilters = ({
  filters,
  setFilters,
  searchFilterApplied,
  onClickSearch,
  callFunction,
}) => {
  const [modals, setModal] = useState(false);

  return (
    <>
      <Modal
        isOpen={modals}
        onRequestClose={() => {
          setModal(false);
        }}
        contentLabel="Add Ingredient Modal"
        ariaHideApp={false}
      >
        <IngForm
          closeModal={() => setModal(false)}
          callFunction={callFunction}
        />
      </Modal>

      <SearchNButtons
        pageName={"ingredients"}
        btnText={"+ Add Ingredients "}
        filters={filters}
        setFilters={setFilters}
        searchFilterApplied={searchFilterApplied}
        onClickSearch={onClickSearch}
        onClickAdd={() => setModal(true)}
      />
    </>
  );
};

export default IngredientsFilters;
